<script setup>
const props = defineProps({
  tag: {
    type: String,
    required: false,
    default: "button",
  },
});
</script>

<template>
  <component :is="props.tag" :class="$style.button">
    <slot />
  </component>
</template>

<style module>
.button {
  display: inline-block;
  height: 40px;
  padding: 0 32px;
  background-color: var(--color-red-base);
  border: 1px solid var(--color-red-base);
  border-radius: 4px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 600;
  line-height: 40px;
  color: #ffffff !important;
  cursor: pointer;
  opacity: 1;
  transition:
    background-color 0.2s ease-in-out,
    border-color 0.2s ease-in-out;
}

.button:hover {
  background-color: var(--color-red-darked);
  border-color: var(--color-red-darked);
}

.button:active {
  background-color: var(--color-red-darked);
  border-color: var(--color-red-darked);
}

.button:disabled {
  opacity: 0.3;
  cursor: default;
}
</style>
